import { render, staticRenderFns } from "./AmenitiesSelect.vue?vue&type=template&id=670a7107&lang=pug&"
import script from "./AmenitiesSelect.vue?vue&type=script&lang=js&"
export * from "./AmenitiesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports